import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useStore } from 'vuex';
import BaseTable from '@/components/common/BaseTable.vue';
import { ref, computed, watch, defineAsyncComponent } from 'vue';
import { User } from '@/types/types';
import { formatDate } from '@/utils/helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'UsersTable',
  props: {
    users: {}
  },
  setup(__props: any) {

const PlanetPopover = defineAsyncComponent(() =>
  import('@/components/planet/PlanetPopover.vue')
);

const store = useStore();

const isLoading = computed(() => store.getters['users/isLoading']);

const props = __props;

const columns = ref([
  { name: 'Name', key: 'name' },
  { name: 'Height', key: 'height' },
  { name: 'Mass', key: 'mass' },
  { name: 'Created', key: 'created' },
  { name: 'Edited', key: 'edited' },
  { name: 'Planet', key: 'homeworld' }
]);

const getPlanetDetails = (planetUrl: string) => {
  const planet = store.getters['planets/planet'](planetUrl);
  return planet ? planet : {};
};

watch(() => props.users, (newUsers) => {
  newUsers.forEach(user => {
    if (user.homeworld && !store.getters['planets/planet'](user.homeworld)) {
      store.dispatch('planets/fetchPlanet', user.homeworld);
    }
  });
}, { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseTable, {
    data: _ctx.users,
    columns: columns.value,
    loading: isLoading.value
  }, {
    homeworld: _withCtx(({ item }) => [
      _createVNode(_unref(PlanetPopover), {
        planet: getPlanetDetails(item.homeworld)
      }, null, 8, ["planet"])
    ]),
    created: _withCtx(({ item }) => [
      _createTextVNode(_toDisplayString(_unref(formatDate)(item.created)), 1)
    ]),
    edited: _withCtx(({ item }) => [
      _createTextVNode(_toDisplayString(_unref(formatDate)(item.edited)), 1)
    ]),
    _: 1
  }, 8, ["data", "columns", "loading"]))
}
}

})